import { KpiListView } from "./KpiListView.js";

export interface ArchivedKpiViewProps {
  /** Open a KPI's detail page. Archived KPIs open the SAME page as active ones
   * (PB-2941) — the page reads its own lifecycle and simply offers nothing to
   * do, which is more honest than a second, subtly different read-only view. */
  readonly onSelectKpi: (kpiId: string) => void;
  /** Tenant-admin — enables the confirmed restore row action. */
  readonly canManage: boolean;
}

const ARCHIVED_FILTERS = { lifecycleStatus: "archived" } as const;

/** Archived keeps retired KPI history readable. Tenant Admins can open a KPI's
 * detail page and restore it to draft; hard delete remains unsupported. */
export function ArchivedKpiView({
  onSelectKpi,
  canManage,
}: ArchivedKpiViewProps): JSX.Element {
  return (
    <section aria-labelledby="archived-kpis-heading" className="space-y-4">
      <h2 id="archived-kpis-heading" className="sr-only">
        Archived KPIs
      </h2>
      <p className="text-body text-pb-text-secondary">
        Retired KPIs are kept for history.
      </p>
      <KpiListView
        filters={ARCHIVED_FILTERS}
        onSelect={onSelectKpi}
        layout="table"
        variant="archived"
        canManage={canManage}
        hasActiveFilters={false}
        emptyTitle="No archived KPIs"
        emptyDescription="KPIs retired from active use will appear here."
      />
    </section>
  );
}
